<template>
	<v-container fluid>
        <v-sheet class="d-flex flex-wrap justify-start" style="background-color:#E3F2FD">
            <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/Visitante`);" max-width="320" outlined color="green lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title class="headline mb-1" style="color:green">Visitante</v-list-item-title>							
							<v-list-item-subtitle style="color:green">Registrar Visita, Buscar, Pasar a Postulante</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="green" size="80">
							<v-icon size="60">account_circle</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet>
            <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/Alumno`);" max-width="320" outlined color="blue lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title class="headline mb-1" style="color:#1565C0">Alumno</v-list-item-title>							
							<v-list-item-subtitle style="color:#1565C0">Buscar, Datos Generales, Matricular...</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="blue" size="80">
							<v-icon size="60">face</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet>
            <!-- <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/TitulacionModalidad`);" max-width="320" outlined color="purple lighten-3">
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title class="headline mb-1" style="color:#6A1B9A">Modalidad Titulacion</v-list-item-title>							
							<v-list-item-subtitle style="color:#6A1B9A">Registro de Modalidad Titulación</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="#BA68C8" size="80">
							<v-icon size="60">class</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet>
            <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/Titulo`);" max-width="320" outlined color="#9575CD" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title class="headline mb-1" style="color:#311B92">Titulo</v-list-item-title>
							<v-list-item-subtitle style="color:#311B92">Registro de Titulo</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="#311B92" size="80">
							<v-icon size="60">school</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet> -->
            <!-- <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/Consejeria`);" max-width="320" outlined color="orange lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title class="headline mb-1" style="color:#EF6C00">Seguimiento</v-list-item-title>							
							<v-list-item-subtitle style="color:#EF6C00">Registro de llamadas, mensajes, ...</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="orange" size="80">
							<v-icon size="60">perm_phone_msg</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet> -->
            <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/Ticket`);" max-width="320" outlined color="yellow lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title style="color:#FBC02D" class="headline mb-1">Ticket</v-list-item-title>							
							<v-list-item-subtitle style="color:#FBC02D">Creación y Busqueda de Ticket</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="#FBC02D" size="80">
							<v-icon size="60">receipt</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet>
            <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/Lms`);" max-width="320" outlined color="indigo lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title style="color:#3F51B5" class="headline mb-1">LMS</v-list-item-title>
							<v-list-item-subtitle style="color:#3F51B5">Integracion con Aulas Virtuales</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="indigo" size="80">
                            <v-icon size="60">history_edu</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet>
            <!-- <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/Crm`);" max-width="320" outlined color="blue-grey lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title style="color:#607D8B" class="headline mb-1">CRM</v-list-item-title>							
							<v-list-item-subtitle style="color:#607D8B">Tickets, LLamadas y Compromisos</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="blue-grey" size="80">
							<v-icon size="60">support_agent</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet> -->
            <!-- <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/CertificadoModular`);" max-width="320" outlined color="teal lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title style="color:#009688" class="headline mb-1">Certificado Modular</v-list-item-title>							
							<v-list-item-subtitle style="color:#009688">Certificado Modular</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="teal" size="80">
							<v-icon size="60">bookmark_added</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet> -->
            <!-- <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/AlumnoDeuda`);" max-width="320" outlined color="red lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title style="color:red" class="headline mb-1">Control de Deuda</v-list-item-title>							
							<v-list-item-subtitle style="color:red">Control de Deuda del alumno por lectura de QR</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="red" size="80">
							<v-icon size="60">qr_code_2</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet> -->
            <!-- <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/AlumnoFoto`);" max-width="320" outlined color="grey lighten-1" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title style="color:#616161" class="headline mb-1">Foto</v-list-item-title>							
							<v-list-item-subtitle style="color:#616161">Toma de foto de alumnos</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="grey darken-1" size="80">
							<v-icon size="60">photo_camera</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet> -->
            <!-- <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/Minedu`);" max-width="320" outlined color="red lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title style="color:red" class="headline mb-1">Minedu</v-list-item-title>							
							<v-list-item-subtitle style="color:red">Modulo de Envio a Minedu</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="red" size="80">
							<GobIcon size="60"></GobIcon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet> -->
            <!-- <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD">
                <v-card @click="$router.push(`/Itinerario`);" max-width="320" outlined color="cyan lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title style="color:#0097A7" class="headline mb-1">Itinerario</v-list-item-title>
							<v-list-item-subtitle style="color:#0097A7">Registro de Itinerario</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="cyan" size="80">
							<v-icon size="60">auto_stories</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet> -->
            <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD" v-if="ssUser.Usuario=='larenas' || ssUser.Usuario=='cquispeh' || ssUser.Usuario=='lferro' || ssUser.Usuario=='ygonzalez' || ssUser.Usuario=='isaavedra'|| ssUser.Usuario=='eccarhuarupay' || ssUser.Usuario=='cgarces' || ssUser.Usuario=='ehilaquita' || ssUser.Usuario=='zamaru' || ssUser.Usuario=='lolivera'">
                <v-card @click="$router.push(`/Matricula`);" max-width="320" outlined color="light-green lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title style="color:#689F38" class="headline mb-1">Matricula</v-list-item-title>
							<v-list-item-subtitle style="color:#689F38">Registro de Matricula</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="light-green" size="80">
							<v-icon size="60">star_rate</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet>
            <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD"  v-if="ssUser.Usuario=='larenas' || ssUser.Usuario=='cquispeh' || ssUser.Usuario=='isaavedra' || ssUser.Usuario=='ygonzalez'" >
                <v-card @click="$router.push(`/AlumnoGeneral/`+ssUser.IdPersonal);" max-width="320" outlined color="red lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title style="color:red" class="headline mb-1">Seguimiento Estudiante</v-list-item-title>
							<v-list-item-subtitle style="color:red">Tramite Documentario, Económico, Matricula ...</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="red" size="80">
							<v-icon size="60">dashboard</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet>
            <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD" v-if="ssUser.Usuario=='larenas' || ssUser.Usuario=='cquispeh' || ssUser.Usuario=='isaavedra' || ssUser.Usuario=='ygonzalez'" >
                <v-card @click="$router.push(`/PersonaCV/admin`);" max-width="320" outlined color="cyan lighten-4" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title style="color:#0097A7" class="headline mb-1">Personal</v-list-item-title>
							<v-list-item-subtitle style="color:#0097A7">Datos Generales, Formación Académica, Especialización ...</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="cyan lighten-2" size="80">
							<v-icon size="60">engineering</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet>
            <!--<v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD" v-if="ssUser.Usuario=='larenas' || ssUser.Usuario=='cquispeh' || ssUser.Usuario=='lferro' || ssUser.Usuario=='kacurios' || ssUser.Usuario=='isaavedra'|| ssUser.Usuario=='eccarhuarupay'">
                <v-card @click="$router.push(`/PlanEstudio`);" max-width="320" outlined color="purple lighten-3" dark>
					<v-list-item three-line>
						<v-list-item-content>
							<v-list-item-title style="color:#7B1FA2" class="headline mb-1">Plan de Estudio</v-list-item-title>
							<v-list-item-subtitle style="color:#7B1FA2">Curricula, Periodo, Seccion, Cursos</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-avatar color="purple" size="80">
							<v-icon size="60">map</v-icon>
						</v-list-item-avatar>
					</v-list-item>
				</v-card>
            </v-sheet>-->
            <!-- <v-sheet class="pa-2" min-width="200" style="background-color:#E3F2FD"></v-sheet> -->
        </v-sheet>
	</v-container>
</template>
<script>
import gql from 'graphql-tag';
import {mapState, mapActions} from 'vuex';
import GobIcon from "../components/GobIcon";
export default {
	name: 'Home',
    mounted(){
        if (this.ssUser) {
            // this.fuMatconsejeriaEnProcesoByIdPersonal();
            this.fuCrmTickets();
        }
    },
	data: () => ({
	}),
    components: {GobIcon},
    computed: {
        ...mapState(['ssUser']),
    },
    methods: {
        ...mapActions(['saCrmTickets', 'saCrmTicketCount', 'saMatConsejerias']),
        async fuMatconsejeriaEnProcesoByIdPersonal(){
            try {
                const response = await this.$apollo.query({
                    query: gql`query matconsejeriaEnProcesoByIdPersonal($IdPersonal: String, $Fecha: String){
                        matconsejeriaEnProcesoByIdPersonal(IdPersonal:$IdPersonal, Fecha: $Fecha){
                            IdConsejeria
                            Consejero
                            IdAlumno
                            Categoria
                            Detalle
                            Procedimiento
                            Fecha
                            FechaProgramado
                            Estado
                            prialumno{
                                Alumno
                                priservicio{
                                    Iniciales
                                }
                            }
                        }
                    }`,
                    variables: {
                        IdPersonal: this.ssUser.IdPersonal,
                        Fecha: new Date().toISOString()
                    }
                })
                this.saMatConsejerias(response.data.matconsejeriaEnProcesoByIdPersonal);
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
        async fuCrmTickets(){
            try {
                const response = await this.$apollo.query({
                    query: gql`query consulta($id_operador_asignado: Int!, $token: String){
                        crmticketcomentarioByid_operador_asignadoByis_finalTop10(id_operador_asignado:$id_operador_asignado, is_final:0, token: $token){
                            id
                            mensaje
                            created_at
                            crmticket{
                                id
                                crmcliente{
                                    id_tipo
                                    prialumno{
                                        Alumno
                                        priservicio{
                                            Iniciales
                                        }
                                    }
                                    admvisita{
                                        Visitante
                                        priservicio{
                                            Iniciales
                                        }
                                    }
                                }
                            }
                        }
                        crmticketcomentarioByid_operador_asignadoByis_finalCount(id_operador_asignado:$id_operador_asignado, is_final:0, token: $token){
                            data
                        }
                    }`,
                    variables: {
                        id_operador_asignado: this.ssUser.IdPersonal,
                        token: new Date().toISOString()
                    }
                })
                this.saCrmTickets(response.data.crmticketcomentarioByid_operador_asignadoByis_finalTop10);
                this.saCrmTicketCount(response.data.crmticketcomentarioByid_operador_asignadoByis_finalCount.data);
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
    }
}
</script>
